/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import _ from 'lodash';
import './OrderSummary.scss';
import formatDate from 'date-fns/format';
import parseIso from 'date-fns/parseISO';
import { Order } from '../../types/Order';
import ProductImage from '../ProductImage';

type Props = {
  orderLines: Order[];
  orderNumber: string;
};

const OrderSummary = (props: Props) => {
  const {
    orderLines = [],
    orderNumber,
  } = props;
  const first = _.first(orderLines);
  let dateLast = '';
  let dateDelivery = '';
  if (first) {
    dateLast = formatDate(parseIso(first.date_ordered), 'do MMM yyy');
    dateDelivery = formatDate(parseIso(first.delivery_date), 'do MMM yyy');
  }
  // @ts-ignore
  let total = 0;
  orderLines.forEach((cur) => total += cur.line_value);

  const renderCutsAndRolls = (item: Order) => {
    return <>
          <div className="row g-0 order-summary__table__content">
              <div className="col-2">
                  <p className="text-grey-small">&nbsp;</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Product</p>
              </div>
              <div className="col-1">
                  <p className="text-grey-small px-2">Width</p>
              </div>
              <div className="col-1">
                  <p className="text-grey-small">Length</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Price Per SQM</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Reference</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Total</p>
              </div>
          </div>
          <div className="row g-0 order-summary__table__content border-bottom-yay">
              <div className="col-2">
                  <div className="product-row text-end">
                      <ProductImage className="product-row__img" imageCode={`${item.product_sku}`.trim()} />
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">{item.product_desc}</p>
                  </div>
              </div>
              <div className="col-1">
                  <div className="product-row px-2">
                      <p className="text-grey-smaller">{item.WIDTH}</p>
                  </div>
              </div>
              <div className="col-1">
                  <div className="product-row">
                      <p className="text-grey-smaller">{item.LENGTH}</p>
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">£{item.line_price.toFixed(2)}</p>
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">{item.line_reference || 'N/A'}</p>
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">
                          £{item.line_value.toFixed(2)} Excl. VAT
                      </p>
                  </div>
              </div>
          </div>
      </>;
  };

  const renderPacksAndPallets = (item: Order) => {
    return <>
          <div className="row g-0 order-summary__table__content">
              <div className="col-2">
                  <p className="text-grey-small">&nbsp;</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Product</p>
              </div>
              <div className="col-1">
                  <p className="text-grey-small px-2">Packs</p>
              </div>
              <div className="col-3">
                  <p className="text-grey-small">Price Per Pack</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Reference</p>
              </div>
              <div className="col-2">
                  <p className="text-grey-small">Total</p>
              </div>
          </div>
          <div className="row g-0 order-summary__table__content border-bottom-yay">
              <div className="col-2">
                  <div className="product-row text-end">
                      <ProductImage className="product-row__img" imageCode={`${item.product_sku}`.trim()} />
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">{item.product_desc}</p>
                  </div>
              </div>
              <div className="col-1">
                  <div className="product-row">
                      <p className="text-grey-smaller px-2">{item.qty_ordered}</p>
                  </div>
              </div>
              <div className="col-3">
                  <div className="product-row">
                      <p className="text-grey-smaller">£{item.line_price.toFixed(2)}</p>
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">{item.line_reference || 'N/A'}</p>
                  </div>
              </div>
              <div className="col-2">
                  <div className="product-row">
                      <p className="text-grey-smaller">
                          £{item.line_value.toFixed(2)} Excl. VAT
                      </p>
                  </div>
              </div>
          </div>
      </>;
  };

  const renderAccessories = (item: Order) => {
    return <>
            <div className="row g-0 order-summary__table__content">
                <div className="col-2">
                    <p className="text-grey-small">&nbsp;</p>
                </div>
                <div className="col-2">
                    <p className="text-grey-small">Product</p>
                </div>
                <div className="col-1">
                    <p className="text-grey-small px-2">QTY</p>
                </div>
                <div className="col-3">
                    <p className="text-grey-small">Price Per Unit</p>
                </div>
                <div className="col-2">
                    <p className="text-grey-small">Reference</p>
                </div>
                <div className="col-2">
                    <p className="text-grey-small">Total</p>
                </div>
            </div>
            <div className="row g-0 order-summary__table__content border-bottom-yay">
                <div className="col-2">
                    <div className="product-row text-end">
                        <ProductImage className="product-row__img" imageCode={`${item.product_sku}`.trim()} />
                    </div>
                </div>
                <div className="col-2">
                    <div className="product-row">
                        <p className="text-grey-smaller">{item.product_desc}</p>
                    </div>
                </div>
                <div className="col-1">
                    <div className="product-row">
                        <p className="text-grey-smaller px-2">{item.qty_ordered}</p>
                    </div>
                </div>
                <div className="col-3">
                    <div className="product-row">
                        <p className="text-grey-smaller">£{item.line_price.toFixed(2)}</p>
                    </div>
                </div>
                <div className="col-2">
                    <div className="product-row">
                        <p className="text-grey-smaller">{item.line_reference || 'N/A'}</p>
                    </div>
                </div>
                <div className="col-2">
                    <div className="product-row">
                        <p className="text-grey-smaller">
                            £{item.line_value.toFixed(2)} Excl. VAT
                        </p>
                    </div>
                </div>
            </div>
        </>;
  };

  const renderSwitch = (item: Order) => {
    if (item.LENGTH > 0 && item.WIDTH > 0) {
      return renderCutsAndRolls(item);
    } else if (item.qty_ordered > 0 && item.WIDTH === 0 && item.sqm > 0) {
      return renderPacksAndPallets(item);
    } else {
      return renderAccessories(item);
    }
  };

  return (
        <div className="order-summary py-4 px-4">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6">Order Number: <span className="medium-grey-text">{orderNumber}</span></div>
                        <div className="col-md-6 text-end">Total: <span className="medium-grey-text">£{total.toFixed(2) }</span></div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            Order Date: <b>{dateLast}</b> | Delivery Date: <b>{dateDelivery}</b>
                        </div>
                    </div>
                </div>
                <div className="hr-line"></div>
                <div className="row g-0 order-summary__table">
                    <div className="order-summary__table__header pb-3 px-5">
                        <div className="order-summary__table__header__left">
                            <p className="text-orange">
                                <b>Order Summary</b>
                            </p>
                        </div>
                    </div>
                    {orderLines.map((o) => renderSwitch(o))}
                </div>
            </div>
        </div>
  );
};

export default OrderSummary;
